import { useFiltersContext } from "components/Shared/GlobalFilter/context/filtersContext"
import { FiltersType } from "components/Shared/GlobalFilter/context/interfaces"

import {
	ADJUST_LEVEL,
	EXCLUDE_FILTER,
	Level,
	filterInfoType,
	FILTER_ORDER_CONFIG,
	EMPTY_FILTER_INFO,
	DEFAULT_FILTER,
	TYPE_SELECT,
} from "./filterInfo.utils"
import { Tuple } from "components/Shared/Interfaces"

const getLastSelectorWithValue = (
	filters: FiltersType,
	filter_order_config = FILTER_ORDER_CONFIG
): Level | undefined => {
	const filterSelected = filter_order_config.find(
		(filterId) => filters[filterId]?.length > 0
	)
	return filterSelected
}
class FilterInfo {
	private validLevel: string[] = []
	private default_all_selected = "0"

	constructor(
		private level: Level,
		private filter_order_config: Level[],
		private exclude_filter: string[]
	) {
		this.validLevel = this.getValidFilter(this.exclude_filter)
	}
	getValidFilter(exclude_filter: string[]): string[] {
		return this.filter_order_config.filter(
			(level) => !exclude_filter.includes(level)
		)
	}
	firstLevel(): string {
		return this.validLevel[this.validLevel.length - 1]
	}

	endLevel(): string {
		return this.validLevel[0]
	}

	getIndex(level: Level, adjust_level: ADJUST_LEVEL): string {
		const i = this.validLevel.indexOf(level)
		const index = Math.max(0, i + adjust_level)
		return this.validLevel[index]
	}

	currentLevel(): string {
		return this.getIndex(this.level, ADJUST_LEVEL.current)
	}

	previousLevel(): string {
		return this.getIndex(this.level, ADJUST_LEVEL.next) || this.firstLevel()
	}

	nextLevel(): string {
		return this.getIndex(this.level, ADJUST_LEVEL.previous) || this.endLevel()
	}

	isMultiSelect(value: Tuple[]): boolean {
		return value.length > 1 || value[0].code === this.default_all_selected
	}
	geTypeSelect(value: Tuple[]): TYPE_SELECT {
		if (this.isSelectAll(value)) {
			return TYPE_SELECT.ALL
		}
		return value.length === 1 ? TYPE_SELECT.UNIQUE : TYPE_SELECT.FEW
	}

	getSelectValueByIndex = (value: Tuple[], index: number): TYPE_SELECT => {
		return value[index].name as TYPE_SELECT
	}
	private isSelectAll = (value: string | any[]) =>
		!value.length ||
		(value.length === 1 && value[0].code === this.default_all_selected)
}

export const filterInfo = (
	default_filter: string = DEFAULT_FILTER,
	exclude_filter: string[] = EXCLUDE_FILTER,
	filter_order_config: Level[] = FILTER_ORDER_CONFIG
): filterInfoType => {
	const { filters } = useFiltersContext()

	const level = getLastSelectorWithValue(filters)

	if (!level) return EMPTY_FILTER_INFO(default_filter)

	const filterInfo = new FilterInfo(level, filter_order_config, exclude_filter)

	return {
		currentLevel: filterInfo.currentLevel(),
		nextLevel: filterInfo.nextLevel(),
		previousLevel: filterInfo.previousLevel(),
		values: filters[level],
		isMultiSelect: filterInfo.isMultiSelect(filters[level]),
		geTypeSelect: filterInfo.geTypeSelect(filters[level]),

		getSelectValueByIndex: (index: number) =>
			filterInfo.getSelectValueByIndex(filters[level], index),
	}
}
